/**
 * Tracks an event to Google Tag Manager.
 * @param {?string} eventCategory The event category; for example, Ecommerce, Downloads, Web Navigation, Videos, etc.
 * @param {?string} eventAction The event action; for example, prodDetailView, addToCart, Please Enquire, etc.
 * @param {?string} eventLabel A label to go with the event. This can generally be anything and can be used to filter events in the Google Analytics dashboard.
 * @param {?number} eventValue The value of the event. May be used in calculations on the Google Analytics dashboard.
 * @param {?any} eventInteraction
 */
export default function trackEvent(eventCategory = "button", eventAction = "click", eventLabel = null, eventValue = null, eventInteraction = null) {
    if (window._sz) {
        _sz.push(["event", eventCategory, eventAction, eventLabel])
    }
    if (window.dataLayer) window.dataLayer.push({
        event: 'gaEvent',
        eventCategory,
        eventAction,
        eventLabel,
        eventValue,
        eventInteraction
    });
}
global.trackEvent = trackEvent;
